var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-dashboard-popup"},[_c('div',{staticClass:"login-dashboard-popup-link",on:{"click":_vm.actionBackToDashboard}},[_vm._v("Dashboard")]),_vm._l((_vm.availablePlatforms),function(platform,key){return _c('login-dashboard-popup-platform',{key:key,attrs:{"data":platform}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }